export const PARTNER_NAV_HREFS = [
  "/partner",
  "/partner/codes",
  "/partner/merchants",
  "/partner/playbook",
];

/** Longest prefix wins so /partner is not active on /partner/codes. */
export function isNavActive(location, href, hrefs) {
  const path = (location || "").split("?")[0];
  const matches = hrefs.filter((h) => path === h || path.startsWith(`${h}/`));
  if (matches.length === 0) return false;
  return matches.reduce((a, b) => (a.length >= b.length ? a : b)) === href;
}
